import React from 'react'
import styled from 'styled-components'
import { colors } from '../../styles/colors'

const Container = styled.div`
    position: absolute;
    cursor: pointer;

    svg line {
        transition: all .5s;
        stroke: ${ props => props.lighten ? colors.white : colors.dark_blue};
    }
    :hover {
        svg line {
            stroke: ${colors.red};
        }
    }
`

export const Cross = ( {lighten} ) => {
    return (
        <Container className="cross-button" lighten={ lighten ? true : false } >
            <svg width="28" height="28" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line x1="1.5" y1="-1.5" x2="51.4647" y2="-1.5" transform="matrix(0.699347 0.714783 -0.699347 0.714783 0 2)" stroke="white" strokeWidth="3" strokeLinecap="round"/>
                <line x1="1.5" y1="-1.5" x2="51.4647" y2="-1.5" transform="matrix(0.699347 -0.714783 0.699347 0.714783 2 39.8574)" stroke="white" strokeWidth="3" strokeLinecap="round"/>
            </svg>
        </Container>
    )
}
